import {Pipe, PipeTransform} from '@angular/core';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {fill} from 'lodash-es';

@Pipe({
  name: 'repeatProductionScheduleItem'
})
export class RepeatProductionScheduleItemPipe implements PipeTransform {
  public transform(productionScheduleItem: ProductionScheduleItemInPathGroup): ProductionScheduleItemInPathGroup[] {
    return fill(Array(productionScheduleItem.quantity), productionScheduleItem);
  }
}
